module.exports = __webpack_public_path__ + "static/media/use10_ch02.b3a561d3.png";